/* eslint-disable no-restricted-syntax */
import { useState } from 'react';

import { useServerClient, configuration as _configuration } from '../useServerClient';
import { useServerParams } from '../useServerParams';

import { schedulerConfigs } from './useSchedulers';

export const configuration = _configuration

export const itemTypes = {
    item: "item",
    brand: "item_brand",
    category: "item_category",
    uom: "item_uom",
    product: "product"
}

export const targetTypes = {
    item: "item",
    brand: "item_brand",
    category: "item_category",
    uom: "item_uom",
    product: "product"
}

export const actionTypes = {
    item: {
        image: "item_image"
    }
}

// export const tagTypes = {
//     item: {
//         image: "image"
//     }
// }

// only for item uom
const decimalPlaces = [0, 1, 2, 3, 4]

const metricTypes = {
    weight: [
        {
            id: 'kg',
            abbreviation: 'kg',
            name: 'kilogram'
        },
        {
            id: 'g',
            abbreviation: 'g',
            name: 'gram'
        }
    ],
    volume: [
        {
            id: 'ml',
            abbreviation: 'ml',
            name: 'mililitre'
        },
        {
            id: 'l',
            abbreviation: 'l',
            name: 'litre'
        }
    ],
    unit: [
        {
            id: 'unit',
            abbreviation: 'unit',
            name: 'unit'
        }
    ]
}

export const uomConfig = {
    decimalPlaces,
    metricTypes
}

const initialUploadValues = {
    uploaded: 0,
    total: 0,
}

export function useItems({
    itemType: _itemType,
    targetType: _targetType,
    actionType: _actionType
    /* , _tagType */
}) {

    const [itemType, setItemType] = useState(_itemType)
    const [targetType, setTargetType] = useState(_targetType)
    const [actionType, setActionType] = useState(_actionType)
    // const [ tagType, setTagType ] = useState(_tagType)

    const { makeCall, makeUploadCall, getError, serverClient } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)
    const [isUploading, setIsUploading] = useState(false)

    const [uploadState, setUploadState] = useState(initialUploadValues)

    const endpoint = "items";
    const endpoint2 = "item";

    const list = async (props) => {

        setIsLoading(true);

        // option for configuration
        let configuration = props?.configuration

        try {

            const {
                itemType: overrideItemType
            } = props

            let url = getListsUrl(`${endpoint}/${itemType}`, props);

            if (overrideItemType) {
                url = getListsUrl(`${endpoint}/${overrideItemType}`, props);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {},
                configuration
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            if (!serverClient.isCancel(error)) {
                setIsLoading(false);
                throw error;
            } else {
                setIsLoading(true);
            }

        }

        return true

    }

    const create = async ({ data, targetType: overrideTargetType, skipSchedulerRequestSubmit = false }) => {

        setIsLoading(true)

        try {

            const url = endpoint2;

            let payload = data

            if (skipSchedulerRequestSubmit === false) {
                // adding the scheduler request
                payload = {
                    ...payload,
                    ...schedulerConfigs.getSchedulerRequestSubmitObject(schedulerConfigs.schedulerIntegrations)
                }
            }

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload
            }

            if (overrideTargetType) {
                postData.scope.target = overrideTargetType
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const createBatch = async ({ data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/bulk_item`;

            // adding the scheduler request
            // if (schedulerConfigs?.schedulerIntegrations) {
            //     if (schedulerConfigs.schedulerIntegrations.length > 0) {

            //         let newData = {}

            //         // append each 
            //         Object.keys(data).forEach(i => {

            //             newData[i] = data[i]
            //             newData = {
            //                 ...newData,
            //                 ...schedulerConfigs.getSchedulerRequestSubmitObject(schedulerConfigs.schedulerIntegrations)
            //             }

            //         })

            //         data = newData

            //         console.log('newData', JSON.stringify(newData))

            //     }
            // }

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) {
                postData.scope.target = overrideTargetType
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const createBatchProps = async ({ data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/bulk_item_props`;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) {
                postData.scope.target = overrideTargetType
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data, targetType: overrideTargetType, skipSchedulerRequestSubmit = false }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/${id}`

            let payload = data

            if (skipSchedulerRequestSubmit === false) {
                // adding the scheduler request
                payload = {
                    ...payload,
                    ...schedulerConfigs.getSchedulerRequestSubmitObject(
                        schedulerConfigs.schedulerIntegrations)
                };
            }

            let postData = {
                scope: {
                    target: targetType,
                    action: actionType,
                },
                payload
            }

            if (overrideTargetType) {
                postData.scope.target = overrideTargetType
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids, itemType: overrideItemType, actionType: overrideActionType, skipSchedulerRequestSubmit = false }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            let url = `${endpoint}/${itemType}/delete`

            if (overrideItemType) {
                url = `${endpoint}/${overrideItemType}/delete`
            }

            // if(overrideActionType === actionTypes.item.deleteItems){ // only for delete item images
            //     url = `${endpoint2}/${parentId}`
            // }

            let payload = {
                ids
            }

            if (skipSchedulerRequestSubmit === false) {
                // adding the scheduler request
                payload = {
                    ...payload,
                    ...schedulerConfigs.getSchedulerRequestSubmitObject(schedulerConfigs.schedulerIntegrations)
                }
            }

            const postData = {
                scope: {
                    target: itemType,
                    action: actionType
                },
                payload
            }

            if (overrideItemType) postData.scope.target = overrideItemType
            if (overrideActionType) postData.scope.action = overrideActionType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, itemType: overrideItemType = '', dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = getUrlWithDataTypes(`${endpoint2}/${itemType}/${id}`, dataTypesArray);

            if (overrideItemType) {
                url = getUrlWithDataTypes(`${endpoint2}/${overrideItemType}/${id}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const upload = async ({ id, payloadFiles }) => {

        setIsUploading(true)

        // reset the upload state
        setUploadState(initialUploadValues)

        try {

            const url = `${endpoint2}/${id}`;

            const formData = new FormData();

            formData.append('scope[target]', `${targetType}`);
            formData.append('scope[action]', `${actionType}`);
            // formData.append('scope[tag]', `${tagType}`);
            formData.append('scope[tag]', ``);

            // for(let i = 0; i < payloadFiles.length; i+=1){
            payloadFiles.forEach((e, i) => {

                // console.log('file -> ', files[1])

                let {
                    referId,
                    description,
                    fileId,
                    file
                } = e


                formData.append(`payload[refer_id][${i}]`, referId);
                formData.append(`payload[description][${i}]`, description);
                formData.append(`payload[file_id][${i}]`, fileId);
                formData.append(`files[${i}]`, file);

            })

            console.log('formData >>>>>> ', payloadFiles, JSON.stringify(formData))

            // files.forEach((e, i) => {
            // let i = 0;
            // for(let a of files){

            //     console.log('file -> ', a)

            //     formData.append(`payload[refer_id][${i}]`, `${i}`);
            //     formData.append(`payload[description][${i}]`, `Description #${i}`);
            //     formData.append(`payload[file_id][${i}]`, "0");
            //     formData.append(`files[${i}]`, a);

            //     i+=1;
            // }


            for (const pair of formData.entries()) {
                // console.log(pair[0]+ ', ' + pair[1]); 
                console.log(`${pair[0]} , ${pair[1]}`)
            }

            const response = await makeUploadCall({
                url,
                formData,
                onUploadProgress: (progressEvent) => {
                    // console.log('upload : progressEvent', progressEvent)
                    const progress = (progressEvent.loaded / progressEvent.total) * 50;

                    setUploadState(
                        {
                            ...uploadState,
                            uploaded: progressEvent.loaded,
                            total: progressEvent.total,
                            percent:
                                parseFloat(
                                    parseInt(progressEvent.loaded, 10) / parseInt(progressEvent.total, 10) * 100
                                ).toFixed(2)
                        }
                    )

                    // setProgress(progress);
                },
                onDownloadProgress: (progressEvent) => {
                    // console.log('download : progressEvent', progressEvent)
                    // const progress = 50 + (progressEvent.loaded / progressEvent.total) * 50;
                    // console.log(progress);
                    // setProgress(progress);
                }
            });

            setIsUploading(false);

            return response;

        } catch (error) {

            setIsUploading(false);
            throw error;

        }

    }

    return {
        isLoading,
        isUploading,
        uploadState,
        filterOperatorTypes,
        list,
        get,
        create,
        createBatch,
        createBatchProps,
        update,
        remove,
        upload
    }

}